import { Cell } from 'bold-ui'
import { TextField } from 'components/form'
import React from 'react'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel } from '../../../model-prescricao'

export interface MedicamentoNaoCadastradoSectionProps {
  path: MetaRoot<MedicamentoFormModel>
  disabled: boolean
}

export default function MedicamentoNaoCadastradoSection({
  path,
  disabled,
}: Readonly<MedicamentoNaoCadastradoSectionProps>) {
  return (
    <>
      <Cell size={7} data-cy='PrincipioAtivo'>
        <TextField
          name={path.principioAtivoText}
          label='Princípio ativo'
          maxLength={200}
          required
          data-cy='PrincipioAtivoTextField'
          disabled={disabled}
        />
      </Cell>
      <Cell size={5}>
        <TextField
          name={path.concentracaoText}
          label='Concentração'
          maxLength={100}
          data-cy='ConcentracaoTextField'
          disabled={disabled}
        />
      </Cell>
    </>
  )
}
